import { BaseComment } from '../base/base-comment';
import { CommentMention } from '../base/comment-mention';
import { InternalUser } from '../users/dto/internal-user';

export class EmployerRecordComment extends BaseComment {
  public employerId!: string;
  public mentions: CommentMention[] = [];

  onDeserialize() {
    super.onDeserialize();
    if (!!this.author) {
      this.author = window?.injector?.Deserialize?.instanceOf(InternalUser, this.author);
    }
  }
}
